// Languages voice input can translate into. Keep in sync with utils/voiceLanguages.js.
// The labels are i18n keys (dashboard namespace).
export const VOICE_TRANSLATE_LANGUAGES = [
  { value: "de", label: "German" },
  { value: "en", label: "English" },
  { value: "tr", label: "Turkish" },
  { value: "ar", label: "Arabic" },
  { value: "pl", label: "Polish" },
  { value: "ro", label: "Romanian" },
  { value: "ru", label: "Russian" },
  { value: "uk", label: "Ukrainian" },
  { value: "it", label: "Italian" },
  { value: "fr", label: "French" },
  { value: "es", label: "Spanish" }
];

export const voiceLanguageLabel = code =>
  VOICE_TRANSLATE_LANGUAGES.find(language => language.value === code)?.label;
